export default __webpack_public_path__ + "static/media/qr.9f253f90.JPG";